import {
  BaseQueryFn,
  createApi,
  FetchArgs,
  fetchBaseQuery,
  FetchBaseQueryError,
  retry,
} from "@reduxjs/toolkit/query/react";
import { message } from "antd";
import { Mutex } from "async-mutex";
import { mode, setUrlSource } from "../../utils";
import { RootState } from "../root/root-state.interface";
import { AuthSliceMethods } from "../slices/authSlice";
import { validateHrWebResponse } from "./validations";
import { GetRefreshedToken } from "../../axios/axiosinstance";
  
  const mutex = new Mutex();
  const baseQuery = fetchBaseQuery({
    baseUrl: setUrlSource(mode),
    prepareHeaders: (headers, { getState }) => {
      const jwtToken = window.localStorage.getItem("token");
      if (jwtToken) {
        headers.set("Authorization", `Bearer ${jwtToken}`);
      }
      headers.set("Content-Type", "application/json; charset=utf-8");
      return headers;
    },
  });
  const baseQueryWithReauth: BaseQueryFn<string | FetchArgs, unknown, FetchBaseQueryError> =
    async (args, api, extraOptions) => {
      const rootState = api.getState() as RootState;
      await mutex.waitForUnlock();
      let result = await baseQuery(args, api, extraOptions);
      if (!rootState.authSlice.isLoggedIn) {
        const release = await mutex.acquire();
        await api.dispatch(AuthSliceMethods.getUserInfo());  
        release();
        return result;
      }
      try {
        validateHrWebResponse(result.data);
      } catch (ex) {
        message.error(String(ex));
      }
  
      if (result.error && result.error.status === "FETCH_ERROR") {
        message.error("Проблема сети - Убедитесь что вы подключены к сети.");
      }

      if (result.error && result.error.status === 500) {
        if (!mutex.isLocked()) {
          const release = await mutex.acquire();
          try {
            const newAccessToken = await GetRefreshedToken();
  
            if (newAccessToken) {
              result = await baseQuery(args, api, extraOptions);
            }
          } catch (ex: any) {
            await api.dispatch(AuthSliceMethods.logout());
          } finally {
            release();
          }
        } else {
          await mutex.waitForUnlock();
          result = await baseQuery(args, api, extraOptions);
        }
      }
      return result;
    };
  
  const staggeredBaseQuery = retry(baseQueryWithReauth, {
    maxRetries: 0,
  });
  
  export const agroApi = createApi({
    reducerPath: "agroApi",
    baseQuery: staggeredBaseQuery,
    endpoints: () => ({}),
    keepUnusedDataFor: 0,
  });
  